import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_FILL_OPACITY, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const WikiPagesIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  fillOpacity = DEFAULT_FILL_OPACITY,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  isFilled,
}) => {
  const path = isFilled ? (
    <path
      d="M17.273 3a1.912 1.912 0 0 1 1.598.867c.58.115 1.155.264 1.718.45.409.135.767.399 1.02.755.254.357.39.787.391 1.229v12.194l-.013.237a2.13 2.13 0 0 1-.193.68 2.078 2.078 0 0 1-.577.73 1.973 1.973 0 0 1-1.52.42l-.226-.045-.016-.004a10.327 10.327 0 0 0-6.75.357l-.02.007a1.968 1.968 0 0 1-1.202.055l-.168-.055-.02-.007a10.33 10.33 0 0 0-6.331-.47l-.42.113-.014.004a1.975 1.975 0 0 1-1.749-.375 2.075 2.075 0 0 1-.577-.733A2.136 2.136 0 0 1 2 18.49V6.302c0-.443.137-.874.39-1.232.251-.352.604-.615 1.007-.75l.016-.007a11.864 11.864 0 0 1 8.374.18c.138.05.29.05.428 0 .724-.274 1.47-.487 2.226-.638.066-.096.14-.187.222-.271A1.91 1.91 0 0 1 16.033 3h1.24zm-5.04 2.63a.707.707 0 0 0-.698.718v12.434c0 .396.312.717.697.717.386 0 .698-.32.698-.717V6.348a.708.708 0 0 0-.698-.717zm3.8-1.195a.535.535 0 0 0-.384.164.567.567 0 0 0-.159.394V9.64l.67-.689.106-.09a.686.686 0 0 1 .88.09l.67.689V4.993a.567.567 0 0 0-.159-.394.537.537 0 0 0-.384-.164h-1.24z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      d="M20.595 6.36a.633.633 0 0 0-.43-.502h-.002c-.315-.101-.633-.19-.953-.267v5.795a.698.698 0 0 1-1.191.493l-1.367-1.366-1.368 1.366a.698.698 0 0 1-1.19-.493V5.587c-.473.115-.94.252-1.397.42v13.132a11.997 11.997 0 0 1 7.117-.212.632.632 0 0 0 .79-.613V6.46l-.009-.1zm-9.298-.355a10.786 10.786 0 0 0-6.99-.302l-.456.146-.017.006a.633.633 0 0 0-.44.603v11.855a.633.633 0 0 0 .718.628l.07-.014a12 12 0 0 1 7.12.212V6.006l-.005-.001zm4.734-1.361a.543.543 0 0 0-.542.543v4.516l.67-.67.106-.087a.698.698 0 0 1 .88.087l.67.67V5.187a.544.544 0 0 0-.543-.543h-1.24zM22 18.314l-.013.23a2.027 2.027 0 0 1-2.29 1.779l-.227-.045-.015-.003a10.604 10.604 0 0 0-6.75.347l-.02.007c-.388.14-.807.157-1.202.052l-.168-.052-.02-.007a10.606 10.606 0 0 0-6.331-.456l-.42.109-.014.003a2.027 2.027 0 0 1-2.53-1.97V6.458a2.026 2.026 0 0 1 1.397-1.927l.016-.006a12.18 12.18 0 0 1 8.374.174.632.632 0 0 0 .194.035h.04a.633.633 0 0 0 .194-.035c.724-.266 1.469-.473 2.226-.619a1.939 1.939 0 0 1 1.59-.832h1.242a1.938 1.938 0 0 1 1.598.843c.58.112 1.154.257 1.718.438a2.027 2.027 0 0 1 1.41 1.929v11.855z"
      fill={color}
    />
  )

  return (
    <SvgWrapper aria-label="Wiki Pages Icon" viewBox={viewBox} size={size}>
      {path}
    </SvgWrapper>
  )
}

export default WikiPagesIcon
